/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Headline figures. Rates are decimals (0..1); the frontend formats them
 * as percentages. Money is what FreightSimple paid the carrier (CAD).
 *
 * @export
 * @interface PerformanceKpis
 */
export interface PerformanceKpis {
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  bookedShipments: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  timesQuoted: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  winRate: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  onTimeDeliveryRate: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  averageTransitDays: number;
  /**
   * What these shipments cost us, in the response's currency. Named
   * "spend" rather than "paid" because it is the agreed rate until the
   * carrier invoices us; nothing has been paid on a shipment still
   * moving.
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  totalSpend: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceKpis
   */
  averageSpendPerShipment: number;
}

/**
 * Check if a given object implements the PerformanceKpis interface.
 */
export function instanceOfPerformanceKpis(
  value: object,
): value is PerformanceKpis {
  if (!("bookedShipments" in value) || value["bookedShipments"] === undefined)
    return false;
  if (!("timesQuoted" in value) || value["timesQuoted"] === undefined)
    return false;
  if (!("winRate" in value) || value["winRate"] === undefined) return false;
  if (
    !("onTimeDeliveryRate" in value) ||
    value["onTimeDeliveryRate"] === undefined
  )
    return false;
  if (
    !("averageTransitDays" in value) ||
    value["averageTransitDays"] === undefined
  )
    return false;
  if (!("totalSpend" in value) || value["totalSpend"] === undefined)
    return false;
  if (
    !("averageSpendPerShipment" in value) ||
    value["averageSpendPerShipment"] === undefined
  )
    return false;
  return true;
}

export function PerformanceKpisFromJSON(json: any): PerformanceKpis {
  return PerformanceKpisFromJSONTyped(json, false);
}

export function PerformanceKpisFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceKpis {
  if (json == null) {
    return json;
  }
  return {
    bookedShipments: json["bookedShipments"],
    timesQuoted: json["timesQuoted"],
    winRate: json["winRate"],
    onTimeDeliveryRate: json["onTimeDeliveryRate"],
    averageTransitDays: json["averageTransitDays"],
    totalSpend: json["totalSpend"],
    averageSpendPerShipment: json["averageSpendPerShipment"],
  };
}

export function PerformanceKpisToJSON(json: any): PerformanceKpis {
  return PerformanceKpisToJSONTyped(json, false);
}

export function PerformanceKpisToJSONTyped(
  value?: PerformanceKpis | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    bookedShipments: value["bookedShipments"],
    timesQuoted: value["timesQuoted"],
    winRate: value["winRate"],
    onTimeDeliveryRate: value["onTimeDeliveryRate"],
    averageTransitDays: value["averageTransitDays"],
    totalSpend: value["totalSpend"],
    averageSpendPerShipment: value["averageSpendPerShipment"],
  };
}
